var _path, _a;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17383 8.8125H5.97656V15.375H3.04688V8.8125H0.644531V6.11719H3.04688V4.03711C3.04688 1.69336 4.45312 0.375 6.5918 0.375C7.61719 0.375 8.70117 0.580078 8.70117 0.580078V2.89453H7.5C6.32812 2.89453 5.97656 3.59766 5.97656 4.35938V6.11719H8.58398L8.17383 8.8125Z",
    fill: "#1877F2"
  })), _a || (_a = /*#__PURE__*/React.createElement("a", {
    href: "https://www.figma.com/design/wMbgHkRz2SmeuHAQ8J7z4k?node-id=66-483"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 0,
    y: -1.125,
    width: 9.375,
    height: 17.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.bc813ac975982e29a6751921a1686124.svg";
export { ForwardRef as ReactComponent };